export function makeUserData (data) {
  return {
    'first_name': data.first_name,
    'last_name': data.last_name,
    'email': data.email,
    'country_code': data.country_code,
    'phone': data.phone,
    'role': data.role,
  }
}
